import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, Ref } from 'vue'
import axios        from 'axios'

// COMPONENTS
import CONSTAPIS    from '@/constants/apis';
import { TIMEOUTTIME } from '@/constants/apis';

// INTERFACES
import { DBSTATUS } from '@/interfaces/SmartLink/Admin'
import { showConsoleError } from '@/functions/errors'
import { TOKEN } from '@/constants/labels';


export default /*@__PURE__*/_defineComponent({
  __name: 'DBstatusview',
  setup(__props) {

const databaseInfo:Ref<DBSTATUS> = ref({})
        
onMounted(async() => {
    /**
     * Captura los valores de la API: 'getDataBaseStatus'
     */
    await axios.get(CONSTAPIS.APIS.value.general.getDBStatus, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((res)=>{
        databaseInfo.value = res.data[0];
    })
    .catch(function (error) {
        showConsoleError(error);
    });
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "defaultCard",
    color: "bgtopology"
  }, {
    default: _withCtx(() => [
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "titlePages" }, " Estado DB ", -1)),
      (databaseInfo.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "ma-0 mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.cambium_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.cambium_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Cambium Data", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.eventos === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.eventos === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Eventos", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.latencia === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.latencia === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Latencia", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value?.LTE_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.LTE_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "subtitleDashboard" }, "LTE Data", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.predicciones === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.predicciones === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Predicciones", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.rajant_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.rajant_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Rajant Data", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.sensores === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.sensores === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Sensores", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.servidor_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.servidor_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Servidor Data", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.ubicacion_gps === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.ubicacion_gps === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "subtitleDashboard" }, "Ubicación GPS", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})